<div class="app-modal">
  <div class="app-modal-body {{this.classCss}}">
    <ng-content></ng-content>
  </div>
</div>
<div class="app-modal-background"></div>
